import {SanityModuleIframe} from 'domains/modules';

export default function SanityIframe({module}: {module: SanityModuleIframe}) {
  return (
    <div className="aspect-w-16 aspect-h-9">
      <iframe src={module.url} className=""></iframe>
    </div>
  );
}
